import type { FaireProductEntity } from "../../entity_types/product";

export const p_x8f6xuxfgy: FaireProductEntity = {
  token: "p_x8f6xuxfgy",
  type: "product",
  name: "Scarvii - Boho Shawl with Pocket",
  brandToken: "b_qrthtbpuwu",
  brandName: "Funkyrel® Atzbranding Limited",
  imageUrl: "https://cdn.faire.com/fastly/3e95141f6130e02ef9fd2f1c79d629a812654f3573ee9a0603e7ad8dbffd7466.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/af1648ecd9106e2d256edaa33fe663d0b946ac87f0a29a3863a72e035dece815.jpeg",
    "https://cdn.faire.com/fastly/225399a963d2682598498df180288eddc08d414baab6c20b7079d2294abe4081.jpeg",
    "https://cdn.faire.com/fastly/69a3ca62949c5b7b2f58e81e2332e6cb977eb8ed7ed0822a8aa8118ef94ec2fa.jpeg",
    "https://cdn.faire.com/fastly/ef18030b31fb76e3b6524230fdb77ba2d96bdc7a7320fc29e8d0703610b1df79.jpeg",
    "https://cdn.faire.com/fastly/10348ed3ce6e892d71d8fafe9963cc9932456840f270b0903618dd2d84c582da.jpeg"
  ],
  priceDollars: 24.25,
  description: "Introducing the boho shawl, a gorgeous new accessory that is perfect for adding a touch of Bohemian flair to any outfit. This shawl is made from a beautiful woven fabric and features an intricate design that is sure to turn heads. Whether you wear it as a scarf, wrap, or sarong, this versatile piece is sure to become a staple in your wardrobe. The boho shawl is the perfect way to add a touch of personality to any outfit, and we know you'll love it!\n Details:\n 1. Shawl measures 120cm wide and 130cm long, one size for all\n 2.Wool like polyester mateiral, soft and bright color \n 3. multiple colors to suit for daily outfits\n\n Atzbranding is a new brand that has established itself in recent years. They are carried by over 200+ happy independent retailers all across the world! \n Our products come with UPC codes for inventory management and retail packaging so we can easily display them on shelves at stores, too!!\n We focus heavily upon cost efficiency while producing high-quality goods.If you have any questions about pricing or shipping feel free to message us through Faire (or email) - our team will do everything possible until this process goes as smoothly.",
  tags: [],
  msrpDollars: 48.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:08:02.670Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
